export const STORAGE_KEYS = {
  theme: 'drawlings-theme',
  panelCollapsed: 'drawlings-panel-collapsed',
  skipClearConfirm: 'drawlings-skip-clear-confirm',
  lastSession: 'drawlings-last-session',
};
